import { DialogService, GridButton } from '@eforall/dashboard';
import { DialogMode } from '@interfaces';
import { GoalCommentEditorDialog, GoalCommentEditorDialogData } from '../../../../../../../ui/widget';
import { GoalDetailsDialogDataService } from '../../goal-details-dialog-data.service';


export function getButtons(dialogService: DialogService, dialogDataService: GoalDetailsDialogDataService) {

	const buttons: GridButton[] = [];

	const addCommentBtn: GridButton = {
		iconClass: 'fa-plus',
		label: 'Add Comment',
		execute: async () => {
			const accGoalId = dialogDataService.goalDetails()?.accGoalId;
			if (!accGoalId) return;
			const dialogData: GoalCommentEditorDialogData = {
				mode: DialogMode.ADD,
				accGoalId,
			};
			await dialogService.showCustom<GoalCommentEditorDialog, GoalCommentEditorDialogData>(GoalCommentEditorDialog, { data: dialogData }, 500, 280);
			await dialogDataService.loadDetails(accGoalId);
		}
	};

	if (dialogDataService.canEdit()) {
		buttons.push(addCommentBtn);
	}

	return buttons;
}